import { SERVICES_API_BASE_URL } from './apiConfig';

export interface StripeAdminSettings {
  publishableKey: string;
  clientId: string;
  secretKey: string;
  webhookSecret: string;
//   hasSecretKey?: boolean;
//   hasWebhookSecret?: boolean;
}

export interface EmailAdminSettings {
  tenantId: string;
  clientId: string;
  from: string;
  clientSecret?: string;
//   hasClientSecret?: boolean;
}

const getAuthHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
  'Content-Type': 'application/json',
});

export const getStripeSettings = async (): Promise<StripeAdminSettings | null> => {
  const response = await fetch(`${SERVICES_API_BASE_URL}/api/adminsettings/stripe`, {
    headers: getAuthHeader(),
  });
  if (!response.ok) throw new Error('Failed to load settings');
  return response.json();
};

export const updateStripeSettings = async (data: Partial<StripeAdminSettings>): Promise<void> => {
  const response = await fetch(`${SERVICES_API_BASE_URL}/api/adminsettings/stripe`, {
    method: 'PUT',
    headers: getAuthHeader(),
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error('Failed to save settings');
};

export const getEmailSettings = async (): Promise<EmailAdminSettings | null> => {
  const response = await fetch(`${SERVICES_API_BASE_URL}/api/adminsettings/email`, {
    headers: getAuthHeader(),
  });
  if (!response.ok) throw new Error('Failed to load settings');
  return response.json();
};

export const updateEmailSettings = async (data: Partial<EmailAdminSettings>): Promise<void> => {
  const response = await fetch(`${SERVICES_API_BASE_URL}/api/adminsettings/email`, {
    method: 'PUT',
    headers: getAuthHeader(),
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error('Failed to save settings');
};
